/**
 * Local Delivery - Date utilities (SGT)
 */
(function () {
  'use strict';

  var SGT_PARTS_FORMATTER = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Singapore',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  function getSgtNowParts() {
    var parts = SGT_PARTS_FORMATTER.formatToParts(new Date());
    var out = { year: 0, month: 0, day: 0, hour: 0, minute: 0 };
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p.type === 'year') out.year = Number(p.value) || 0;
      else if (p.type === 'month') out.month = Number(p.value) || 0;
      else if (p.type === 'day') out.day = Number(p.value) || 0;
      else if (p.type === 'hour') out.hour = Number(p.value) || 0;
      else if (p.type === 'minute') out.minute = Number(p.value) || 0;
    }
    return out;
  }

  function isoToUtcDate(iso) {
    var parts = String(iso || '').split('-');
    if (parts.length !== 3) return null;
    var y = Number(parts[0]);
    var m = Number(parts[1]);
    var d = Number(parts[2]);
    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
    return new Date(Date.UTC(y, m - 1, d));
  }

  function utcDateToIso(dateObj) {
    if (!dateObj || typeof dateObj.getUTCFullYear !== 'function') return '';
    var y = dateObj.getUTCFullYear();
    var m = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    var d = String(dateObj.getUTCDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function todayStrSgt() {
    var p = getSgtNowParts();
    return String(p.year).padStart(4, '0') + '-' + String(p.month).padStart(2, '0') + '-' + String(p.day).padStart(2, '0');
  }

  function maxDateStrSgt(days) {
    var base = isoToUtcDate(todayStrSgt());
    if (!base) return '';
    base.setUTCDate(base.getUTCDate() + (days || 120));
    return utcDateToIso(base);
  }

  function addDaysStrSgt(days) {
    var base = isoToUtcDate(todayStrSgt());
    if (!base) return '';
    base.setUTCDate(base.getUTCDate() + (days || 0));
    return utcDateToIso(base);
  }

  function minutesSinceMidnightSgt() {
    var p = getSgtNowParts();
    return (p.hour * 60) + p.minute;
  }

  function formatDisplayDate(iso) {
    if (!iso) return '';
    var d = new Date(iso + 'T12:00:00');
    return d.toLocaleDateString('en-SG', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
  }

  function getSlotsForDate(slots, dateStr, blackoutDates) {
    if (!slots || !dateStr) return [];
    var d = new Date(dateStr + 'T12:00:00');
    var day = d.getDay();
    var iso = dateStr;
    if (blackoutDates && blackoutDates.some(function (b) { return b.date === iso; })) return [];
    return slots.filter(function (s) { return s.availableDays && s.availableDays.indexOf(day) >= 0; });
  }

  function isPastCutoff(slot, dateStr) {
    if (!slot || !dateStr) return true;
    var today = todayStrSgt();
    if (dateStr !== today) return false;
    var cutoffMin = (slot.cutoffHour || 0) * 60 + (slot.cutoffMinute || 0);
    var nowMin = minutesSinceMidnightSgt();
    return nowMin >= cutoffMin;
  }

  window.WF_LD_DATE_UTILS = {
    todayStrSgt: todayStrSgt,
    maxDateStrSgt: maxDateStrSgt,
    addDaysStrSgt: addDaysStrSgt,
    minutesSinceMidnightSgt: minutesSinceMidnightSgt,
    formatDisplayDate: formatDisplayDate,
    getSlotsForDate: getSlotsForDate,
    isPastCutoff: isPastCutoff,
  };
})();
